var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 676,
    height: 392,
    viewBox: "0 0 676 392",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "biztantuGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3fbaeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#3e89c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3d59a8"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 199.26 303.29 C 157.61 304.45, 123.66 278.35, 103.03 243.80 C 55.86 164.82, 110.41 58.88, 208.31 72.07 C 257.33 78.67, 286.94 109.69, 302.41 152.41 C 316.14 190.31, 312.76 232.22, 313.91 269.77 C 314.39 285.41, 316.24 298.23, 326.14 309.99 C 344.75 332.10, 378.92 335.10, 403.32 321.38 C 410.34 317.43, 416.62 312.12, 421.44 305.64 C 430.01 294.13, 433.75 279.66, 434.93 265.36 C 436.30 248.61, 434.70 231.73, 434.29 214.97 C 433.85 196.60, 433.63 178.20, 434.96 159.85 C 435.07 158.39, 435.18 156.92, 435.31 155.45 C 440.19 97.55, 492.02 56.34, 551.58 72.78 C 616.25 95.78, 615.46 141.61, 617.87 200.30 C 619.21 234.91, 616.23 271.14, 618.23 305.41",
    fill: "none",
    stroke: "url(#biztantuGradient)",
    strokeWidth: 60,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: 2000,
    strokeDashoffset: 2000
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "2000;0;2000;2000;0;2000",
    keyTimes: "0;0.2344;0.4214;0.5846;0.8101;1",
    dur: "5.617s",
    repeatCount: "indefinite",
    calcMode: "linear"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.111f2699acf0f8b1690788a28a480434.svg";
export { ForwardRef as ReactComponent };